import { render } from "./indexDocumentsComponent.vue?vue&type=template&id=77b32a43"
import script from "./indexDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./indexDocumentsComponent.vue?vue&type=script&lang=js"

import "./indexDocumentsComponent.vue?vue&type=style&index=0&id=77b32a43&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__